export default {
  index: [
    {
      path: '/qybzj',
      component: resolve => require(['./qybzjIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/qy_bzj/_router.js